export default {
  title: '會員管理',
  memberList: '會員列表',
  memberLevel: '會員等級',
};
